import { useMemo } from 'react';
import { useLanguage } from '../../../locale/useTextLocalizer';

export function useIntl(): {
  locale: string;
  language: string;
  script: string | null;
  region: string | null;
  getCollator: () => Intl.Collator;
} | null {
  const localeId = useLanguage();
  const oResult = useMemo(() => {
    const rLocale = localeId.replace(/_/g, '-');
    const aResult = rLocale.split('-');
    let language: string = localeId,
      region = null,
      script = null;

    if (aResult.length === 1) {
      language = aResult[0];
    } else if (aResult.length === 2) {
      language = aResult[0];
      region = aResult[1];
    } else if (aResult.length > 2) {
      language = aResult[0];
      script = aResult[1];
      region = aResult[2];
    }
    language = language.toLowerCase();
    script =
      script &&
      script.toLowerCase().replace(/^[a-z]/, function ($) {
        return $.toUpperCase();
      });

    region = region && region.toUpperCase();
    if (aResult)
      return {
        locale: localeId,
        language,
        script,
        region,
        getCollator: () => {
          // TODO : need to include the check to see if locale has been changed by user in settings.
          // If the locale is updated by user in settings then use that locale.
          return new Intl.Collator(aResult[0]);
        },
      };
    return null;
  }, [localeId]);
  return oResult;
}
